// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__21VAv","title":"Info_title__26jy9","links":"Info_links__3b0bB","link":"Info_link__1Oi9L","logo":"Info_logo__3y-P9"};